import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

type GoogleOneTapDismissedProps = {
  reason: string;
};

type GoogleOneTapFailedProps = {
  reason: string;
};

export type GoogleOneTapDisplayedEvent = TrackingEvent<
  "Google One Tap Displayed",
  Record<string, never>
>;

export type GoogleOneTapDismissedEvent = TrackingEvent<
  "Google One Tap Dismissed",
  { dismiss_reason: string }
>;

export type GoogleOneTapFailedEvent = TrackingEvent<
  "Google One Tap Failed",
  { failure_reason: string }
>;

export async function trackGoogleOneTapDisplayedEvent(): TrackingEventResponse {
  return await trackEvent("Google One Tap Displayed", {
    props: {},
    withRequestSource: true,
  });
}

export async function trackGoogleOneTapDismissedEvent({
  reason,
}: GoogleOneTapDismissedProps): TrackingEventResponse {
  return await trackEvent("Google One Tap Dismissed", {
    props: {
      dismiss_reason: reason,
    },
    withRequestSource: true,
  });
}

export async function trackGoogleOneTapFailedEvent({
  reason,
}: GoogleOneTapFailedProps): TrackingEventResponse {
  return await trackEvent("Google One Tap Failed", {
    props: {
      failure_reason: reason,
    },
    withRequestSource: true,
  });
}
